
import React from "react";
import AddItemQuantityPresets from "../add-item/form/AddItemQuantityPresets";
import { useThemeConfig } from "@/components/ui/theme-config-provider";

interface QuantityPresetSelectorProps {
  presets: string[];
  selectedValue: string;
  onSelect: (value: string) => void;
}

const QuantityPresetSelector = ({ presets, selectedValue, onSelect }: QuantityPresetSelectorProps) => {
  const { theme } = useThemeConfig();
  
  return (
    <AddItemQuantityPresets 
      presets={presets}
      selectedValue={selectedValue}
      onSelect={onSelect}
      style={{
        borderRadius: theme.buttonBorderRadius || '0.375rem'
      }}
    />
  );
};

export default QuantityPresetSelector;
